import {Route} from 'react-router';
import React from 'react';

import {addGenericErrorToast} from '@albert-io/atomic';
import {clearSkillPathCache} from './StudentSkillPath/hooks/useStudentSkillPath';
import {getFeatureFlagStatus} from 'client/components/FeatureFlag/featureFlag.utils';
import sessionStore from 'client/Session/SessionStore';
import StudentHomepage from './StudentHomepage';
import StudentHomepageAssignmentsTabContent from './StudentAssignments/StudentAssignments';
import {StudentIndependentPractice} from './StudentIndependentPractice/StudentIndependentPractice';
import {StudentSkillPath} from './StudentSkillPath/StudentSkillPath';
import WelcomeComponent from './Welcome';

const BASE_ROUTE = '/home';

export enum Routes {
  Assignments = `${BASE_ROUTE}/assignments`,
  Base = BASE_ROUTE,
  IndependentPractice = `${BASE_ROUTE}/independent-practice`,
  SkillPath = `${BASE_ROUTE}/skill-path`,
  Welcome = `${BASE_ROUTE}/welcome`
}

const StudentHomepageRoutes = (
  <Route
    component={StudentHomepage}
    onEnter={(_nextState, replace, callback) => {
      if (!sessionStore.hasValidSession()) {
        replace('/log-in');
        callback?.();
      } else if (!sessionStore.isStudent()) {
        replace('/classes');
        callback?.();
      } else {
        getFeatureFlagStatus('new_student_dashboard')
          .then((isFlagEnabled) => {
            if (!isFlagEnabled) {
              replace('/classes');
            }
          })
          .catch(() => {
            addGenericErrorToast();
          })
          .finally(() => {
            callback?.();
          });
      }
    }}
    onLeave={() => {
      clearSkillPathCache();
    }}
    path='home'
  >
    <Route
      component={StudentHomepageAssignmentsTabContent}
      path='(class/:classroomId/)assignments'
    />
    <Route
      component={StudentIndependentPractice}
      path='(class/:classroomId/)independent-practice'
    />
    <Route component={StudentSkillPath} path='(class/:classroomId/)skill-path' />
    <Route component={WelcomeComponent} path='welcome' />
  </Route>
);

export default StudentHomepageRoutes;
